export enum ChannelType {
  CHANNEL_TYPE_UNSET = 'CHANNEL_TYPE_UNSET', // Do not use, needed because of proto3 limitations
  CHANNEL_OXXOPAY = 'CHANNEL_OXXOPAY',
  CHANNEL_PHYSICAL_STORE = 'CHANNEL_PHYSICAL_STORE',
  CHANNEL_SUPPORT = 'CHANNEL_SUPPORT',
  CHANNEL_DATA_REWARDS_INSTANT = 'CHANNEL_DATA_REWARDS_INSTANT',
  CHANNEL_SELLER_REWARD = 'CHANNEL_SELLER_REWARD',
  CHANNEL_PRE_PROVISIONING = 'CHANNEL_PRE_PROVISIONING',
  CHANNEL_API = 'CHANNEL_API',
  CHANNEL_OPENPAY = 'CHANNEL_OPENPAY',
  CHANNEL_CREDIT_CARD = 'CHANNEL_CREDIT_CARD',
  CHANNEL_SELLERAPP = 'CHANNEL_SELLERAPP',
  CHANNEL_DATA_REWARDS_BANKABLE = 'CHANNEL_DATA_REWARDS_BANKABLE',
  CHANNEL_PORTAL = 'CHANNEL_PORTAL',
}
